import client from './client';
import { Customer } from '../types/entities';
import { ApiResponse, CreateCustomerRequest } from '../types/api';

export const customerAPI = {
  getAll: async (): Promise<Customer[]> => {
    const response = await client.get('/customers');
    return response.data.data;
  },

  getById: async (id: number): Promise<Customer> => {
    const response = await client.get(`/customers/${id}`);
    return response.data.data;
  },

  create: async (data: CreateCustomerRequest): Promise<Customer> => {
    const response = await client.post('/customers', data);
    return response.data.data;
  },

  update: async (id: number, data: Partial<CreateCustomerRequest>): Promise<Customer> => {
    const response = await client.put(`/customers/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<ApiResponse<null>> => {
    const response = await client.delete(`/customers/${id}`);
    return response.data;
  },
};
